import lodash from 'lodash'
import { colors, colorsHex } from './colors'
import { getItemsBuhtaByConfig } from '/src/utils/getItemsBuhtaByConfig'

export const button = {
  id: 'button',
  // tName: 'personalizations.button.button',
  template: 'modal',
  preview: 'cover',

  originPersonalizationsIds: [
    628, // Кнопка
    716, // Кнопка  арт.993
  ],

  getPersConfig,
  getItemsBuhta,
}

/** Формирует массив с выбранными персоналками и моделями
 * (нужно для отображения на 4-м шаге) */
function getPersConfig(store, oldModelValues) {
  const items = []
  const modelValues = {}

  const params = {
    store,
    oldModelValues,
    items,
    modelValues,
    originIdsAvailable: this.originIdsAvailable,
    originPersonalizations: this.originPersonalizations,
  }

  getColor(params)

  return {
    modelValues,
    items: lodash.sortBy(items, ['sort']),
  }
}

/** Формирует массив с выбранными персоналками бухты
 * (нужно для запроса цены) */
function getItemsBuhta({ modelValues }) {
  const originPersonalizations = this.originPersonalizations
  const idBuhta = 628
  const idParam = 97
  const idValue = modelValues?.color?.id

  return getItemsBuhtaByConfig(originPersonalizations, idBuhta, [
    {
      idParam,
      idValue,
    },
  ])
}

/**
 * Выбор цвета кнопки
 */
function getColor(params) {
  const { oldModelValues, items, modelValues, originPersonalizations } = params

  let idBuhta = 628
  let idParam = 97

  if (originPersonalizations[716]) {
    idBuhta = 716
    idParam = 138
  }

  let values = []
  if (originPersonalizations[idBuhta].params) {
    const val = originPersonalizations[idBuhta].params.find((item) => item.id === idParam)
    if (val?.values?.length) {
      values = val.values.map((n) => ({
        ...n,
        background: colors[n.id] ?? n.hex,
        hex: colorsHex[n.id] ?? n.hex,
      }))
    }
  }

  if (values.length > 0) {
    items.push({
      id: 'color',
      tName: 'personalizations.button.color',
      template: 'selectClassicColor',
      sort: 10,
      values,
    })

    // Дефолтный цвет кнопки - серебро
    let defaultIndex = values.findIndex((n) => n.hex === '#989BA0')
    if (defaultIndex < 0) {
      defaultIndex = 0
    }
    if (oldModelValues.color) {
      modelValues.color = values.find((i) => i.id === oldModelValues.color.id) ?? values[defaultIndex]
    } else {
      modelValues.color = values[defaultIndex]
    }
  }
}
